module.exports = __webpack_public_path__ + "img/icon-blockquote.17d34b26.svg";